<template>
  <v-card>
    <v-card-text>
      <PatientDiseasesList v-model="value" return-object></PatientDiseasesList>
    </v-card-text>

    <v-card-text>
      <pre>{{ value }}</pre>
    </v-card-text>
  </v-card>
</template>

<script>
import AutocompleteICD10 from "@/components/AutocompleteICD10.vue";
import DatePicker from "@/components/forms/DatePicker.vue";
import TaskTemplatesList from "@/views/pages/tasks/components/TaskTemplatesList.vue";
import PatientDiseasesList from "@/components/PatientDiseasesList.vue";

export default {
  name: "test",
  components: { PatientDiseasesList, TaskTemplatesList, DatePicker, AutocompleteICD10 },

  data() {
    return {
      value: null,
    };
  },
};
</script>

<style scoped></style>
